import Cookies from 'js-cookie';

export default class {

    static get(url, headers = {}, config = {}) {
        return axios.get(url, this.getConfigObject(headers, config));
    }

    static post(url, data = {}, headers = {}, config = {}) {
        return axios.post(url, data, this.getConfigObject(headers, config));
    }

    static patch(url, data = {}, headers = {}, config = {}) {
        return axios.patch(url, data, this.getConfigObject(headers, config));
    }

    static delete(url, headers = {}, config = {}) {
        return axios.delete(url, this.getConfigObject(headers, config));
    }

    static ApiKey() {
        return Cookies.get('X-USER') || '';
    }

    static getConfigObject(headers = {}, config = {}) {
        return {
            ...config,
            headers: this.appendHeaders(headers),
        };
    }

    static appendHeaders(headers) {
        headers.Authorization = 'Bearer ' + this.ApiKey();
        return headers;
    }
}
